var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('AnnotatedPathwaySearch',{attrs:{"term":_vm.term,"darkmode":_vm.darkmode,"title":_vm.title,"subtitle":_vm.subtitle}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }